import { tabbablesIn } from './tabbables';

/** Цель фокуса составного поля формы — объект с `focus()`, который `*Control` отдаёт в `field.ref` */
export interface IFieldFocusTarget {
    focus: (options?: FocusOptions) => void;
}

/**
 * Фокус формы (`setFocus`, ошибка валидации) у составного поля без своего фокусируемого корня — на его начало: первый
 * доступный с Tab элемент внутри (поле-триггер пикера, первый флажок группы, «Добавить» у чипов). Корень читается в
 * момент фокуса: что внутри, зависит от режима поля.
 */
export const fieldFocusTarget = (root: HTMLElement): IFieldFocusTarget => ({
    focus: (options) => tabbablesIn(root)[0]?.focus(options),
});

/**
 * Ref корня составного поля для `field.ref` у `*Control`: форма получает `fieldFocusTarget(корень)`, при размонтировании
 * — `null`. `<Atom ref={fieldFocusRef(field.ref)} />`.
 */
export const fieldFocusRef =
    (ref: (target: IFieldFocusTarget | null) => void) =>
    (root: HTMLElement | null): void => {
        ref(root && fieldFocusTarget(root));
    };
